// Which host Firebase Auth should run the redirect sign-in against.
//
// The app is reachable on two Firebase Hosting domains, and Hosting serves
// /__/auth/* on both. Sign-in has to use the one the page was actually loaded
// from: a single baked authDomain is cross-origin for the other domain, and a
// cross-origin redirect flow breaks under third-party-cookie blocking, which is
// exactly the case installed PWAs hit.
//
// Every entry needs THREE registrations elsewhere, and each one fails
// differently when it is missing:
//
//   1. Firebase Auth authorized domains, and
//   2. https://<host>/__/auth/handler as an authorized redirect URI on the
//      Google OAuth client — without either, sign-in dies with
//      "Access blocked: this app's request is invalid".
//   3. The reCAPTCHA Enterprise key's allowed domains (App Check). Without it
//      no App Check token can be issued on that origin, so every /api/* call
//      fails with 401 appcheck_unavailable while sign-in still works fine.
//      This one bit us: spesen.bitforge.ch was live and signing users in for
//      weeks, but scanning was impossible from it.
//
// See "Adding a Hosting domain" in docs/setup.md for the commands.
const HOSTING_DOMAINS = [
  "spesen.bitforge.ch",
  "expenses-app-5df99.web.app",
];

/**
 * Resolve the authDomain for the host currently serving the app.
 *
 * Unrecognised hosts (localhost in development, anything else) fall back to the
 * configured domain, because only our Hosting domains serve an auth handler and
 * guessing would guarantee a failed redirect.
 */
export function resolveAuthDomain(hostname: string, fallback: string): string {
  const host = (hostname ?? "").trim().toLowerCase();
  return HOSTING_DOMAINS.includes(host) ? host : fallback;
}
